import root from 'window-or-global';
import { combineReducers } from 'redux';
import product from './ProductReducers';
import storeOffers from './StoreOffersReducers';
import admin from '../../admin/reducers';
import payments from '../../payments/reducers/products';
import cart from 'reducers/CartReducers';

let rootReducer;
if (root.ADMIN_STATE) {
  rootReducer = combineReducers({
    product,
    storeOffers,
    payments,
    cart,
    admin,
  });
} else {
  rootReducer = combineReducers({
    product,
    storeOffers,
    payments,
    cart,
  });
}

// exported to waggle as well
export default rootReducer;



// WEBPACK FOOTER //
// ./src/product/reducers/index.js